let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hb9rK")).then(() => parcelRequire('84wGJ'));